//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import YL3158 from "../../../../Media/Image/052.jpg";

//Element
class K820Q1 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement(Row, {},
            //Element
            React.createElement(Col, { md: 5 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB f029qa" },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q035zf" },
                        //Element
                        "02"
                    ),
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB g371o1" },
                        //Element
                        "Renewable Energy"
                    ),
                    //Element
                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB tv2821" },
                        //Element
                        "Sustainable Services ",
                        //Element
                        React.createElement("br", {}),
                        //Element
                        React.createElement("em", {},
                            //Element
                            "For a Better "
                        ),
                        //Element
                        React.createElement("br", {}),
                        //Element
                        "Tomorrow"
                    )
                )
            ),
            //Element
            React.createElement(Col, { md: 7 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j392d8" },
                    //Element
                    React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                        //Element
                        React.createElement("img", { alt: "Renewable Energy", title: "Renewable Energy", src: YL3158, width: "856", height: "auto" })
                    ),
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB a725gw" },
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "At Temas Electric, we don’t just transmit electricity — we shape the future. With our experienced team and innovative approach, we provide solutions in Electrical Contracting, Maintenance and Repair, Project Development, Energy Systems, and Automation."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "In response to various global threat driven by the climate crisis, the use of renewable energy sources is rapidly increasing as a sustainable alternative to fossil fuels."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Temas provides turnkey installation services for renewable energy projects, including rooftop, façade, land-based, and agricultural solar power plants, as well as wind power plants."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "We also provide warranty, maintenance, and operational services."
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default K820Q1;